// Package imports:
import React from 'react';

interface IOwnProps {
    onClick?: () => void;
}

const MobileHamburgerMenu: React.FC<IOwnProps> = ({
    onClick
}) => {
    return (
        <div
            className='KCL_mobile-hamburger-menu'
            onClick={onClick}
        >
            <span className='hamburger-icon'>
                <span></span>
                <span></span>
                <span></span>
            </span>
        </div>
  );
}

export default MobileHamburgerMenu;
